module.exports = __webpack_public_path__ + "img/logo.7ed3cf4e.jpg";